export const GET_ACHIEVEMENT_LIST_REQUEST = "GET_ACHIEVEMENT_LIST_REQUEST";
export const GET_ACHIEVEMENT_LIST_SUCCESS = "GET_ACHIEVEMENT_LIST_SUCCESS";
export const GET_ACHIEVEMENT_LIST_FAILED = "GET_ACHIEVEMENT_LIST_FAILED";
